'use strict';

exports.__esModule = true;

var _ProductData = require('../dataTypes/ProductData');

var _ProductData2 = _interopRequireDefault(_ProductData);

var _objectHelpers = require('../../../../objectHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This event tracks a purchase
 *
 * @name Purchase
 * @param {Object} params
 * @param {string} params.id
 * @param {string} params.currencyCode
 * @param {string} params.affiliation
 * @param {number} params.total
 * @param {number} params.tax
 * @param {number} params.shipping
 * @param {string} params.coupon
 * @param {ProductData[]} params.products - list of products in cart
 */
var Purchase = function Purchase(_ref) {
    var id = _ref.id,
        currencyCode = _ref.currencyCode,
        affiliation = _ref.affiliation,
        total = _ref.total,
        tax = _ref.tax,
        shipping = _ref.shipping,
        coupon = _ref.coupon,
        products = _ref.products;

    _classCallCheck(this, Purchase);

    this.event = 'purchase';
    this.ecommerce = (0, _objectHelpers.removeUndefined)({
        currencyCode: currencyCode,
        purchase: {
            actionField: {
                id: id,
                affiliation: affiliation,
                revenue: total,
                tax: tax,
                shipping: shipping,
                coupon: coupon
            },
            products: products
        }
    });
};

exports.default = Purchase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/enhancedEcommerce/Purchase.js
// module id = 855
// module chunks = 0